// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"413":"8d0bc4f8","566":"3e629223","882":"67c69a96"}[chunkId] + ".chunk.js";
};